import { useEffect } from 'react';
import { SuperPayBankAccountDTO } from 'shared/modules/superpay/SuperPayDTO';
import { trackSuperPayEvent } from '../../data/SuperPayAnalytics';
import { logPaymentInfo } from '../PaymentLogger';

export function useTrackAccountDetailsOpened(
  verificationStatus?: SuperPayBankAccountDTO['verification_status'],
) {
  useEffect(() => {
    trackSuperPayEvent({ name: 'Carrier Opened SuperPay Settings Page' });
    logPaymentInfo(
      'Carrier Opened SuperPay Settings Page',
      'BankAccountDetailsPage',
      {
        verificationStatus,
      },
    );
  }, [verificationStatus]);
}
